<template>
    <van-popup
        v-model="open"
        position="bottom"
        safe-area-inset-bottom
        get-container=".pages"
    >
        <div class="popup-header">
            <div class="popup-header__title">数据来源（领料单）</div>
            <van-icon name="cross" size="16px" color="#ACACAC" style="font-weight: bold;" @click="open = false" />
        </div>
        <div class="file-group">
            <div class="file-card">
                <div style="display: flex;align-items: center;margin-bottom: 12px;">
                    <van-image
                        width="36"
                        height="40"
                        :src="require('@/assets/image/filesIcon/excel-icon.png')"
                        class="file-icon"
                    />
                    <div style="flex: 1;overflow: hidden;">
                        <div class="file-name">
                            <span class="single-line-hide">{{ splitFileName(materialFile.name).name }}</span>
                            <span>.{{ splitFileName(materialFile.name).extension }}</span>
                        </div>
                        <div class="file-size">{{ fileSizeFormat(materialFile.size) }}</div>
                    </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="file-date">{{ parseTime(materialFile.lastModified,"{y}-{m}-{d}") }}</div>
                    <div>
                        <!-- <div class="file-text-btn" style="color: #FF484A;" @click="handleFileOpen">打开</div> -->
                        <van-button
                            type="warning"
                            size="mini"
                            @click="handleFileOpen"
                        >打开</van-button>
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { Popup , Icon , Image , Button } from "vant";
import { splitFileName , fileSizeFormat , parseTime } from "@/utils/index.js";
import { fileUpload } from "@/api/material/materialDataUpload/index.js"
export default {
    components: {
        [Popup.name]: Popup,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Button.name]: Button,
    },
    data(){
        return {
            open: false,
            materialFile: {},
            initialData: {}
        }
    },
    created(){
        this.initialData = this.deepClone(this.$data);
    },
    methods: {
        splitFileName,
        fileSizeFormat,
        parseTime,
        init(options){
            this.reset();
            if (options) {
                Object.keys(options).map((key) => {
                    if (!this.$data.hasOwnProperty(key)) return;
                    this[key] = ["[object Object]", "[object Array]"].includes(
                    Object.prototype.toString.call(options[key])
                    )
                    ? this.deepClone(options[key])
                    : options[key];
                });
            };
            this.open = true;
        },
        async handleFileOpen(){
            let fileUploadInfo = await this.fileUpload();
            window.uni.postMessage({data: {
                type: 'open-excel', 
                url: fileUploadInfo.url,
            }});
        },
        async fileUpload(){
            try {
                this.$loading.open();
                let file = this.materialFile;
                let formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "material");
                let { data } = await fileUpload({
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                return Promise.resolve(data);
            } catch (error) {
                console.log("上传失败",error);
                return Promise.reject(error);
            }
        },
        reset(){
            Object.keys(this.initialData).map((key) => {
                if (key === "initialData") return false;
                this[key] = ["[object Object]", "[object Array]"].includes(
                Object.prototype.toString.call(this.initialData[key])
                )
                ? this.deepClone(this.initialData[key])
                : this.initialData[key];
            });
        }
    }
}
</script>

<style scoped lang="scss">
    ::v-deep.van-popup {
        padding: 0 12px 24px 12px !important;
        box-sizing: border-box;
    }
    .popup-header {
        padding: 12px 0;
        font-size: 16px;
        line-height: 24px;
        color: #393939;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .file-group {
        background-color: #FFF;
        // border-top: 1px solid #EFF0F4;
        .file-card {
            border: 1px solid #EFEFEF;
            border-radius: 4px;
            overflow: hidden;
            padding: 16px;
            .file-icon {
                margin-right: 11px;
                flex-shrink: 0;
            }
            .file-name {
                font-size: 16x;
                line-height: 24px;
                font-weight: bold;
                color: #3D3833;
                display: flex;
                align-items: center;
            }
            .file-size {
                font-size: 12px;
                line-height: 20px;
                color: #85807B;
            }
            .file-date {
                font-size: 12px;
                line-height: 20px;
                color: #85807B;
            }
            .file-text-btn + .file-text-btn {
                margin-left: 8px;
            }
            .file-text-btn {
                font-size: 12px;
                line-height: 20px;
                display: inline-block;
            }
            .single-line-hide {
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
            }
        }
    }
    .van-button {
        padding: 0 12px;
        height: 20px;
        font-size: 12px;
        border-radius: 2px;
        background-color: #EC892E;
    }
</style>